(() => {
  const root = document.querySelector('[data-ulabco-page]');
  if (!root) return;
  document.body.classList.add('ulab-home-page');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const nav = root.querySelector('.ulab-nav');
  const mobileConversion = root.querySelector('.ulab-mobile-conversion');
  const revealItems = [
    ...root.querySelectorAll(
      '.ulab-value-grid > div, .ulab-section-head, .ulab-product-card, .ulab-project-hero, .ulab-project-form-card, .ulab-project-benefits > div, .ulab-industry-media, .ulab-center-actions, .ulab-creations-panel > div:first-child, .ulab-creation-tile, .ulab-contact-panel > div'
    ),
  ];

  revealItems.forEach((item, index) => {
    item.classList.add('reveal-in');
    item.style.setProperty('--reveal-order', String(index % 4));
  });

  if (!reduceMotion && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  let scrollFrame = 0;
  const updateScrollState = () => {
    scrollFrame = 0;
    const scrollY = window.scrollY || 0;
    if (nav) nav.classList.toggle('is-scrolled', scrollY > 24);
    if (mobileConversion) {
      mobileConversion.classList.toggle('is-visible', window.matchMedia('(max-width: 820px)').matches);
    }
  };

  const scheduleScrollState = () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(updateScrollState);
  };

  updateScrollState();
  window.addEventListener('scroll', scheduleScrollState, { passive: true });
  window.addEventListener('resize', scheduleScrollState, { passive: true });

  if (!reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    root.querySelectorAll('.ulab-product-card').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const px = (event.clientX - rect.left) / rect.width;
        const py = (event.clientY - rect.top) / rect.height;
        card.style.setProperty('--card-ry', `${(px - 0.5) * 2.4}deg`);
        card.style.setProperty('--card-rx', `${(0.5 - py) * 2.1}deg`);
        card.style.setProperty('--media-x', `${(px - 0.5) * -5}px`);
        card.style.setProperty('--media-y', `${(py - 0.5) * -5}px`);
      });

      card.addEventListener('pointerleave', () => {
        card.style.removeProperty('--card-ry');
        card.style.removeProperty('--card-rx');
        card.style.removeProperty('--media-x');
        card.style.removeProperty('--media-y');
      });
    });
  }

  const form = root.querySelector('[data-quote-form]');
  const error = root.querySelector('[data-quote-error]');
  if (form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const company = String(data.get('company') || '').trim();
      const email = String(data.get('email') || '').trim();
      const quantity = String(data.get('quantity') || '').trim();
      const variant = String(data.get('variant') || '').trim();
      const personalization = String(data.get('personalization') || '').trim();
      const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!company || !validEmail || !quantity || !variant || !personalization) {
        if (error) error.hidden = false;
        return;
      }

      if (error) error.hidden = true;
      const body = [
        'Cześć ULABCO,',
        '',
        'Chcę przygotować zapytanie hurtowe.',
        '',
        `Firma: ${company}`,
        `Osoba kontaktowa: ${String(data.get('name') || '').trim() || '-'}`,
        `E-mail: ${email}`,
        `Pakiet ilościowy: ${quantity}`,
        `Wariant produktu: ${variant}`,
        `Personalizacja: ${personalization}`,
        `Termin: ${String(data.get('deadline') || '').trim() || '-'}`,
        '',
        `Notatka: ${String(data.get('notes') || '').trim() || '-'}`,
      ].join('\n');

      window.location.href = `mailto:ulabbusiness@gmail.com?subject=${encodeURIComponent('Zapytanie hurtowe ULABCO')}&body=${encodeURIComponent(body)}`;
    });
  }

  function scrollToHashTarget() {
    const hash = window.location.hash.replace('#', '');
    if (!hash) return;
    const target = document.getElementById(decodeURIComponent(hash));
    if (!target) return;
    const headerOffset = hash === 'start' ? 0 : 92;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
  }

  function scheduleHashScroll() {
    window.requestAnimationFrame(scrollToHashTarget);
    window.setTimeout(scrollToHashTarget, 180);
    window.setTimeout(scrollToHashTarget, 680);
  }

  scheduleHashScroll();
  window.addEventListener('hashchange', scheduleHashScroll);
  window.addEventListener('load', scheduleHashScroll);
})();

